import { render, staticRenderFns } from "./passAction.vue?vue&type=template&id=252be07e&"
import script from "./passAction.vue?vue&type=script&lang=js&"
export * from "./passAction.vue?vue&type=script&lang=js&"
import style0 from "./passAction.vue?vue&type=style&index=0&id=252be07e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports